import { Select } from '@components/shared/Select'
import { useUser } from '@hooks/useUser'

import type { PeriodCompetenceSelectProps } from './types'

export const CompetencePeriodSelect = ({ periodValue, setPeriodValue }: PeriodCompetenceSelectProps) => {
  const { userData } = useUser()

  return (
    <Select
      hasController={false}
      name="periodCompetence"
      label="Período Competência"
      placeholder="Selecione o período"
      value={periodValue}
      options={
        userData?.competencePeriod?.length
          ? userData?.competencePeriod?.map((item) => ({
              label: item.label,
              value: item.monthNumber
            }))
          : []
      }
      onChange={({ target }) => setPeriodValue(target.value as number)}
    />
  )
}
